module.exports = __webpack_public_path__ + "media/src/assets/Images/DownloadRE-4a828fa11c2f5eee00b430a9483167ed.svg";